/**
 * The SKU in the price row of the product page (blocks/product-price-row.liquid).
 * A click copies the code without the word «Артикул». For two seconds the copy icon turns into a tick
 * and data-copied («Скопійовано») shows under the code. The code is read at the click, so after a
 * variant change (assets/product-sku.js swaps the text) the new one is copied.
 */
class SkuCopy extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
    clearTimeout(Number(this.dataset.timer));
  }

  #onClick = async (/** @type {MouseEvent} */ event) => {
    if (!(event.target instanceof Element) || !event.target.closest('button')) return;

    const value = this.querySelector('[ref="sku"]')?.textContent?.trim();
    const tip = this.querySelector('[role="status"]');
    if (!value || !(tip instanceof HTMLElement)) return;

    try {
      await navigator.clipboard.writeText(value);
    } catch {
      // No clipboard access (an old browser or no permission): copy through a selected field
      const field = document.createElement('textarea');
      field.value = value;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.append(field);
      field.select();
      document.execCommand('copy');
      field.remove();
    }

    tip.textContent = this.dataset.copied ?? '';
    this.toggleAttribute('data-done', true);
    clearTimeout(Number(this.dataset.timer));
    this.dataset.timer = String(
      setTimeout(() => {
        this.removeAttribute('data-done');
        tip.textContent = '';
      }, 2000)
    );
  };
}

if (!customElements.get('sku-copy')) {
  customElements.define('sku-copy', SkuCopy);
}
